// extracted by mini-css-extract-plugin
export var checkbox = "_40-0";
export var circle = "_40-3";
export var horizontalContainer = "_40-7";
export var sm = "_40-5";
export var switch0 = "_40-2";
export var switchDisabled = "_40-8";
export var switchEnabled = "_40-1";
export var textSwitchContainer = "_40-9";
export var textSwitchOption = "_40-a";
export var textSwitchOptionSelected = "_40-b";
export var verticalContainer = "_40-6";
export var xs = "_40-4";